
import { ICalendarEventsRes } from '../../models/calendar-model';
import { ITrainerBioRes } from '../../models/trainerbio.model';
import getService from '../getService';
import postService from '../postService';
import putService from '../putService';

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';


class CalendarService {
  
  async getCalendar(uuid: number,startdate: string, enddate: string) {
    const response = await getService.get(`${CONFIG_API_URL}users/${uuid}/calendar/${startdate}/${enddate}`)
    const res :ICalendarEventsRes = response.data
    return res;
  }

  async getCourseCalendar(id: number|any, startdate: string, enddate: string) {
    const response = await getService.get(`${CONFIG_API_URL}courses/${id}/calendar/${startdate}/${enddate}`)
    const res :ICalendarEventsRes = response.data
    return res;
  }
  
  async setCalendar(uuid: string,formData: any) {
    const response = await postService.post(`${CONFIG_API_URL}users/${uuid}/calendar`, formData);
    return response.data;
  }

  async setCourseCalendar(uuid: string, formData: any) {
    const response = await postService.post(`${CONFIG_API_URL}courses/${uuid}/calendar`, formData);
    return response.data;
  }
  
  async updateCourseCalendar(uuid:string, data: any) {
    const response = await putService.put(`${CONFIG_API_URL}courses/${uuid}/calendar`, data);
  
    return response.data;
  }
 
}

export default new CalendarService();